// views/auth/register.js  (ES)
export const register_i18n = {
  alts: {
    banner: "fondo de registro",
    brand: "WA Checkin",
    footerLogo: "WA Checkin",
  },

  aria: {
    toggleReferral: "activar o desactivar el código de afiliado",
    togglePassword: "mostrar u ocultar contraseña",
  },

  texts: {
    inviteTitle: "¡Enhorabuena!",
    inviteText: "{name} te ha invitado a WACheckin: tienes un {percent}% de descuento en tus {months} primeros meses.",
    inviteApplied: "Aplicado desde tu enlace de invitación.",
    panelKicker: "WACheckin · 2026",
    panelCta: "Conoce WACheckin",
    langLabel: "Idioma",
    panelTitle: "Configúralo una vez. El resto va solo.",
    panelDesc: "El enlace del check-in, la bienvenida, las llaves y el parte a las autoridades salen sin que tengas que acordarte.",
    title: "Crea tu cuenta",
    infoTitle: "Regístrate en minutos",
    infoDesc:
      "Completa tus datos y empieza a automatizar el check-in y la comunicación con tus huéspedes.",
    referralHint: "Actívalo solo si te han dado uno.",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
  },

  labels: {
    inviteCode: "Código de invitación",
    name: "Nombre",
    email: "Email",
    password: "Contraseña",
    phone: "Teléfono",
    referralCode: "Código de afiliado",
  },

  placeholders: {
    name: "Introduce tu nombre",
    email: "Introduce tu Email",
    password: "Crea una contraseña",
    referralCode: "Código",
  },

  buttons: {
    submit: "Crear cuenta",
    submitting: "Creando cuenta...",
    signIn: "Inicia sesión",
  },

  validation: {
    phoneRequired: "Escribe tu número, no solo el prefijo.",
    phoneInvalid: "Ese número no es válido. Revísalo.",
    invalidReferralCode: "El código de afiliado no es válido.",
  },

  toast: {
    signupSuccess: "¡Cuenta creada con éxito!",
    referralCodeError:
      "El código de referido no es correcto. Introduce uno válido o deja el campo vacío.",
    signupError: "Error al registrarte.",
    networkError: "Error de conexión. Intenta de nuevo.",
  },
};
